// src/components/CoursesLayout.jsx
import React from "react";
import { useLocation } from "react-router-dom";
import SubLayout from "./SubLayout.jsx";
import NavTabs from "./NavTabs.jsx"; // 공용 탭 컴포넌트

export default function CoursesLayout({ data, children }) {
  const { pathname } = useLocation();
  const isPlaces = pathname.startsWith("/places");

  // 히어로 타이틀은 현재 탭에 맞게
  const title = isPlaces ? "강습 장소" : "강습 과정";

  // 탭 구성: 라벨/경로만 맞춰주면 NavTabs가 활성화 상태 처리
  const tabs = [
    { label: "강습 과정", path: "/courses" },
    { label: "강습 장소", path: "/places" },
  ];

  // SubLayout(히어로) + 기존 탭 섹션(.about-nav) 재사용
  return (
    <SubLayout data={data} title={title}>
      {/* Tabs — NoticeLayout과 동일한 DOM 구조/클래스 */}
      <section className="about-nav">
        <div className="container">
          <NavTabs tabs={tabs} mobileCols={2} />
        </div>
      </section>

      {/* 본문 */}
      <main>{children}</main>
    </SubLayout>
  );
}
